import { render, staticRenderFns } from "./NoticeBox.vue?vue&type=template&id=4fab20ba&"
import script from "./NoticeBox.vue?vue&type=script&lang=js&"
export * from "./NoticeBox.vue?vue&type=script&lang=js&"
import style0 from "./NoticeBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports